const ChevronLeft = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="24"
            viewBox="0 0 13 24"
            fill="none"
        >
            <path
                d="M11.9922 23L0.992187 12L11.9922 1"
                stroke="#696158"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ChevronLeft
